import React, { useCallback } from 'react';
import { CSS } from '@dnd-kit/utilities';
import { ProductListItem, ProductListProps } from 'components/ProductList/ProductListItem';
import { useSortable } from '@dnd-kit/sortable';

export const DraggableProductListItem = (props: ProductListProps) => {
    const { attributes, listeners, setNodeRef: productDragRef, transform, transition, isDragging } = useSortable({
        id: props.product.productId,
    });

    if (transform) {
        transform.scaleX = 1;
        transform.scaleY = 1;
    }

    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
        opacity: isDragging ? 0 : 1,
    };

    const handleProductClick = useCallback(
        (productId, categoryId) => {
            if (props.onProductClick) {
                props.onProductClick(productId, categoryId);
            }
        },
        [props.onProductClick],
    );

    return (
        <div ref={productDragRef} style={style} {...listeners} {...attributes}>
            <ProductListItem
                product={props.product}
                storeCategory={props.storeCategory}
                draggableItem={true}
                onProductClick={handleProductClick}
            />
        </div>
    );
};
